/* eslint-disable react/jsx-props-no-spreading */
import {
  ImageProps,
  AvatarProps,
  Avatar,
  Image,
  SkeletonCircle,
  Skeleton,
} from '@chakra-ui/react';
import * as React from 'react';

import { getObject } from '~/components/atoms';
import noImage from './noImage.png';

const useS3Image = (imageKey: string | undefined) => {
  const [src, setSrc] = React.useState<string | undefined>(undefined);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    if (!imageKey) return;
    if (/http/i.test(imageKey)) {
      setSrc(imageKey);

      return;
    }

    setLoading(true);
    const fetchImage = () => {
      getObject(imageKey)
        .then((imageSrc) => setSrc(imageSrc || undefined))
        .catch((_e) => setSrc(undefined));
      setLoading(false);
    };
    void fetchImage();
  }, [imageKey]);

  return { src, loading };
};

const S3Image: React.FC<
  ImageProps & {
    imageKey: string | undefined;
  }
> = ({ imageKey, ...props }) => {
  const { src, loading } = useS3Image(imageKey);

  return loading ? (
    <Skeleton />
  ) : (
    <Image {...props} src={src} fallbackSrc={noImage} />
  );
};

export const UserAvatar: React.FC<
  AvatarProps & {
    imageKey: string | undefined;
  }
> = ({ imageKey, name, size = 'sm', ...props }) => {
  const { src, loading } = useS3Image(imageKey);

  return loading ? (
    <SkeletonCircle />
  ) : (
    <Avatar
      src={src}
      size={size}
      name={imageKey ? undefined : name}
      {...props}
    />
  );
};

export default S3Image;
